import { useMemo } from 'react'
import { parseGuestFromSmartParameterId } from '../../smart-parameters/helpers'
import { getLinkProductFeature } from '../helpers/product-feature'

export const useParsedGuest = ({
  smartParameterId,
  linkProductFeature,
}: {
  smartParameterId?: string | null
  linkProductFeature?: ReturnType<typeof getLinkProductFeature>
}) => {
  return useMemo(() => {
    // First try to parse from smart parameter
    const guestFromSmartParam = parseGuestFromSmartParameterId(smartParameterId)
    if (guestFromSmartParam) {
      return guestFromSmartParam
    }

    // Fallback to primaryGuest email from linkProductFeature
    if (linkProductFeature?.primaryGuest?.email) {
      return {
        type: 'GuestEmailRequest' as const,
        guestEmail: linkProductFeature.primaryGuest.email,
      }
    }

    return undefined
  }, [smartParameterId, linkProductFeature])
}
